export enum AddEditMode {
  ADD,
  EDIT,
}
